// app/src/features/submit/RunStatusSlot.jsx
import React from "react";
import RunStatus from "../../components/RunStatus.jsx";

/**
 * The frame's `runStatus` slot: the running forecast's status card (the run on screen, or the
 * question just asked on the new-question page before its run exists), its research questions and
 * the cancel control.
 */
export default function RunStatusSlot({ ctx }) {
  const {
    statusRun,
    runStatusOn,
    researchQuestions,
    forecastLiveProgressEnabled,
    railPanelOpen,
    cancellableRun,
    onCancelForecast,
  } = ctx;
  return (
    <>
      <RunStatus
        run={statusRun}
        visible={runStatusOn}
        questions={researchQuestions}
        liveProgress={forecastLiveProgressEnabled}
        leftInset={railPanelOpen ? "var(--rail-panel-w)" : 0}
        canCancel={!!cancellableRun}
        onCancel={onCancelForecast}
      />
    </>
  );
}
